import {Component, HostListener, Inject, viewChild, ElementRef} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { AuthService } from 'src/app/_core/auth.service';

@Component({
  selector: 'app-bytabit-pay-dialog',
  standalone: false,
  templateUrl: './bytabit-pay-dialog.component.html',
  styleUrl: './bytabit-pay-dialog.component.scss',
})
export class BytabitPayDialogComponent {
	trustedIframeUrl: SafeResourceUrl;
	saveToWallet: any = false;
	isRevealed = false;
	lastMessageRecieved: any;
	private  exIframe = viewChild<ElementRef<HTMLIFrameElement>>('exIframe');
	@HostListener('window:message', ['$event'])
	onMessage(e) {
		console.log(e.data);
		this.handleIframeLoadedEvent(e );
	}

	constructor(
		private sanitizer: DomSanitizer,
		public appService: AppService,
		public entityService: EntityService,
		public authService: AuthService,
		public dialogRef: MatDialogRef<BytabitPayDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.redirectURL);
		this.lastMessageRecieved = new Date().valueOf();
		this.checkLastMessage();
	}

	checkLastMessage() {
		setTimeout(() => {
			if (this.isRevealed) return;
			const diffSeconds = (new Date().valueOf() - this.lastMessageRecieved) / 1000;
			if (diffSeconds > 45) {
				this.dialogRef.close({ mode: 'error', params: {} });
			}
			else this.checkLastMessage();
		}, 1000 * 5 );
	}

	onFrameLoaded(ev) {
		try {
			const _location = ev.currentTarget.contentWindow.location;
			const href = _location.href;
			console.log("EXTERNAL PAY DIALOG", href);
		} catch (e) { }
	}

	handleIframeLoadedEvent(event: MessageEvent): void {
		const tabitMessage = this.parseTrustedTabitMessage(event);
		if (tabitMessage) return this.handleTabitMessage(tabitMessage);
	}

	private parseTrustedTabitMessage(event: MessageEvent) {
		const allowedOrigin = this.data.allowedOrigin;
		if (!allowedOrigin || event.origin !== allowedOrigin) return null;
		const iframeWindow = this.exIframe()?.nativeElement?.contentWindow;
		if (!iframeWindow || event.source !== iframeWindow) return null;
		const message = event.data;
		if (
			message?.channel !== 'tabit-payments' ||
			message?.v !== 1
		) {
			return null;
		}
		return message;
	}

	private handleTabitMessage(message): void {
		this.lastMessageRecieved = new Date().valueOf();
		const payload = message.payload;
		console.log("handleTabitMessage", message);
		switch (message.type) {
			case TabitPaymentSessionMessageType.LOADING:
			case TabitPaymentSessionMessageType.STATUS:
				return;
			case TabitPaymentSessionMessageType.DISPLAY_REQUIRED:
				if (!this.isRevealed && this.data.startHidden) {
					this.isRevealed = true;
					this.dialogRef.addPanelClass('visible');
				}
				return;
			case TabitPaymentSessionMessageType.SUCCESS:
				this.dialogRef.close({ mode: 'success', params: payload });
				return;
			case TabitPaymentSessionMessageType.ERROR:
				if (this.isSessionExpired(payload)) {
					this.dialogRef.close({ mode: 'cancel', params: payload });
					return;
				}
				this.dialogRef.close({ mode: 'error', params: payload });
				return;
			case TabitPaymentSessionMessageType.CANCELLED:
				this.dialogRef.close({ mode: 'cancel', params: payload });
				return;
		}
	}

	isSessionExpired(payload?): boolean {
		return payload?.session?.status === TabitPaymentSessionState.EXPIRED;
	}

	close() {
		this.dialogRef.close({ mode: "cancel" });
	}

}

export enum TabitPaymentSessionMessageType {
	LOADING = 'loading',
	STATUS = 'status',
	DISPLAY_REQUIRED = 'displayRequired',
	SUCCESS = 'success',
	ERROR = 'error',
	CANCELLED = 'cancelled',
}
export enum TabitPaymentSessionState {
	PENDING = 'pending',
	PENDING_OTP = 'pendingOtp',
	PENDING_THREE_DS = 'pendingThreeDs',
	COMPLETED = 'completed',
	FAILED = 'failed',
	CANCELLED = 'cancelled',
	EXPIRED = 'expired',
}
